import React, { useState, useEffect } from "react";
import InputWithLabel from "./InputWithLabel";
import Button from "../buttons/button";
import moment from "moment";
import { capitalize } from "../../../helpers/Utils";
import SelectBox from "./SelectBox ";
import { useGetSuppliersListQuery } from "../../../features/expense/expenseApi";
import useTranslator from "../../../hooks/useTranslator";

const initialFormData = {
  vendor_name: "", // Changed from supplier_id to match URL param
  bill_number: "",
  bill_start_date: "", // Changed from bill_date_start to match URL param
  bill_end_date: "", // Changed from bill_date_end to match URL param
  due_date: "", // Changed to single due_date to match URL param
  status: "",
};

const today = moment().format("YYYY-MM-DD");

const BillPaidFilter = ({ onApplyFilter, date, onClose }) => {
  const [filtersData, setFiltersData] = useState(initialFormData);
  const { _t } = useTranslator();

  const { data: suppliers, isLoading: getSupplierLoading } =
    useGetSuppliersListQuery();

  const statusOptions = [
    { value: "paid", label: "Paid" },
    { value: "unpaid", label: "Unpaid" },
  ];

  const handleChange = (e) => {
    setFiltersData({ ...filtersData, [e.target.name]: e.target.value });
  };

  const handleReset = (e) => {
    e.preventDefault();
    setFiltersData(initialFormData);
    onApplyFilter(initialFormData);
    if (onClose) {
      onClose();
    }
  };

  const handleApply = (e) => {
    e.preventDefault();
    onApplyFilter({ ...filtersData });
    if (onClose) {
      onClose();
    }
  };

  return (
    <div className="dropdown_body">
      <h5 className="mb-3 border-bottom">Filter</h5>
      {/* Vendor/Supplier Selection */}
      <SelectBox
        label={_t("vendor", "Vendor")}
        name="vendor_name" // Changed from supplier_id to match URL param
        value={filtersData.vendor_name}
        onChange={handleChange}
        options={
          suppliers?.data?.map((supplier) => ({
            value: supplier.vendor_name,
            label: _t(supplier.vendor_name, supplier.vendor_name),
          })) || []
        }
        isLoading={getSupplierLoading}
      />

      {/* Bill Number */}
      <InputWithLabel
        label={_t("bill_number", "Bill Number")}
        type="text"
        placeholder={_t("bill_number", "Bill Number")}
        name="bill_number"
        value={filtersData.bill_number}
        onChange={handleChange}
      />

      {/* Status Paid/Unpaid */}
      {/* <SelectBox
        label="Payment Status"
        name="status"
        value={filtersData.status}
        onChange={handleChange}
        options={statusOptions}
      /> */}

      {/* Bill Date Range - Start */}
      <InputWithLabel
        label={_t("bill_date_from", "Bill Date (From)")}
        type="date"
        name="bill_start_date" // Changed from bill_date_start to match URL param
        value={filtersData.bill_start_date}
        max={today}
        onChange={handleChange}
      />

      {/* Bill Date Range - End */}
      <InputWithLabel
        label={_t("bill_date_to", "Bill Date (To)")}
        type="date"
        name="bill_end_date" // Changed from bill_date_end to match URL param
        value={filtersData.bill_end_date}
        min={filtersData.bill_start_date}
        onChange={handleChange}
      />

      {/* Due Date - Single Field */}
      <InputWithLabel
        label={_t("due_date", "Due Date")}
        type="date"
        name="due_date" // Changed from due_date_start/due_date_end to match URL param
        value={filtersData.due_date}
        onChange={handleChange}
      />

      <div className="d-flex justify-content-between mt-3">
        <Button onClick={handleReset} label={_t("reset", "Reset")} className="reset_btn" />
        <Button className="cmn_btn" label={_t("apply", "Apply")} onClick={handleApply} />
      </div>
    </div>
  );
};

export default BillPaidFilter;